
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Playground } from 'docz';
import PropsTable from './docs/PropsTable';
import { COMMON, LAYOUT } from './docs/system_props';
import { Input, TextArea, InputGroup, Select, Checkbox, RadioButton, RadioButtonGroup, FormError } from './Input';
import { Box } from './Box';
import { Text } from './Text';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "forms"
    }}>{`Forms`}</h1>
    <h2 {...{
      "id": "input"
    }}>{`Input`}</h2>
    <Playground __position={0} __code={'<Box mb=\"m\">\n  <Input\n    name=\"field_name\"\n    label=\"Basic input\"\n    placeholder=\"Placeholder text\"\n    type=\"text\"\n  />\n</Box>\n<Box mb=\"m\">\n  <Input\n    name=\"field_name\"\n    label=\"Valid input\"\n    placeholder=\"Placeholder text\"\n    type=\"text\"\n    value=\"A valid value\"\n    valid\n  />\n</Box>\n<Box>\n  <Input\n    name=\"field_name\"\n    label=\"Input with error\"\n    placeholder=\"Placeholder text\"\n    type=\"text\"\n    error=\"This input has an error\"\n  />\n</Box>'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Input,
      TextArea,
      InputGroup,
      Select,
      Checkbox,
      RadioButton,
      RadioButtonGroup,
      FormError,
      Box,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <Box mb="m" mdxType="Box">
    <Input name="field_name" label="Basic input" placeholder="Placeholder text" type="text" mdxType="Input" />
  </Box>
  <Box mb="m" mdxType="Box">
    <Input name="field_name" label="Valid input" placeholder="Placeholder text" type="text" value="A valid value" valid mdxType="Input" />
  </Box>
  <Box mdxType="Box">
    <Input name="field_name" label="Input with error" placeholder="Placeholder text" type="text" error="This input has an error" mdxType="Input" />
  </Box>
    </Playground>
    <h3 {...{
      "id": "props"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'input'
      }, {
        name: 'name',
        description: 'html name attribute',
        type: 'String',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'label',
        description: 'A label',
        type: 'React node',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'valid',
        description: 'Value is valid',
        type: 'Boolean',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'error',
        description: 'A field-level error',
        type: 'React node',
        defaultValue: 'undefined',
        responsive: 'false'
      }]}
    </PropsTable>
    <h2 {...{
      "id": "textarea"
    }}>{`TextArea`}</h2>
    <Playground __position={2} __code={'<Box mb=\"m\">\n  <TextArea\n    label=\"Basic textarea\"\n    name=\"field_name\"\n    placeholder=\"Placeholder text\"\n  />\n</Box>\n<Box mb=\"m\">\n  <TextArea\n    label=\"Valid textarea\"\n    name=\"field_name\"\n    placeholder=\"Placeholder text\"\n    valid\n  />\n</Box>\n<Box mb=\"m\">\n  <TextArea\n    label=\"Textarea with error\"\n    name=\"field_name\"\n    placeholder=\"Placeholder text\"\n    error=\"This is an error\"\n  />\n</Box>'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Input,
      TextArea,
      InputGroup,
      Select,
      Checkbox,
      RadioButton,
      RadioButtonGroup,
      FormError,
      Box,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <Box mb="m" mdxType="Box">
    <TextArea label="Basic textarea" name="field_name" placeholder="Placeholder text" mdxType="TextArea" />
  </Box>
  <Box mb="m" mdxType="Box">
    <TextArea label="Valid textarea" name="field_name" placeholder="Placeholder text" valid mdxType="TextArea" />
  </Box>
  <Box mb="m" mdxType="Box">
    <TextArea label="Textarea with error" name="field_name" placeholder="Placeholder text" error="This is an error" mdxType="TextArea" />
  </Box>
    </Playground>
    <h3 {...{
      "id": "props-1"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'input'
      }, {
        name: 'name',
        description: 'html name attribute',
        type: 'String',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'label',
        description: 'A label',
        type: 'React node',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'valid',
        description: 'Value is valid',
        type: 'Boolean',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'error',
        description: 'A field-level error',
        type: 'React node',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'resize',
        description: 'resize',
        type: 'vertical | none',
        defaultValue: 'vertical',
        responsive: 'false'
      }]}
    </PropsTable>
    <h2 {...{
      "id": "inputgroup"
    }}>{`InputGroup`}</h2>
    <Playground __position={4} __code={'<Text>Basic input group</Text>\n<InputGroup mt=\"s\" mb=\"m\">\n  <Input name=\"field_1\" placeholder=\"Placeholder for field 1\" type=\"text\" />\n  <Input name=\"field_2\" placeholder=\"Placeholder for field 2\" type=\"text\" />\n  <Input name=\"field_3\" placeholder=\"Placeholder for field 3\" type=\"text\" />\n</InputGroup>\n<Text>Input group with a textarea</Text>\n<InputGroup mt=\"s\" mb=\"m\">\n  <Input name=\"field_1\" placeholder=\"Placeholder for field 1\" type=\"text\" />\n  <Input name=\"field_2\" placeholder=\"Placeholder for field 2\" type=\"text\" />\n  <TextArea name=\"field_3\" placeholder=\"This is a textarea\" type=\"text\" />\n</InputGroup>\n<Text>Input group with validated fields</Text>\n<InputGroup mt=\"s\" mb=\"m\" valid>\n  <Input\n    name=\"field_1\"\n    placeholder=\"Placeholder for field 1\"\n    type=\"text\"\n    value=\"Valid value\"\n    valid\n  />\n  <Input\n    name=\"field_2\"\n    placeholder=\"Placeholder for field 2\"\n    type=\"text\"\n    value=\"Another valid value\"\n    valid\n  />\n  <Input\n    name=\"field_3\"\n    placeholder=\"Placeholder for field 3\"\n    type=\"text\"\n    value=\"One more valid value\"\n    valid\n  />\n</InputGroup>\n<Text>Input group with an error</Text>\n<InputGroup mt=\"s\" invalid>\n  <Input name=\"field_1\" placeholder=\"Placeholder for field 1\" type=\"text\" />\n  <Input\n    name=\"field_2\"\n    placeholder=\"Placeholder for field 2\"\n    type=\"text\"\n    value=\"Some invalid value\"\n    error=\"This field has an error\"\n  />\n  <Input\n    name=\"field_3\"\n    placeholder=\"Placeholder for field 3\"\n    type=\"text\"\n    value=\"A valid value\"\n    valid\n  />\n</InputGroup>'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Input,
      TextArea,
      InputGroup,
      Select,
      Checkbox,
      RadioButton,
      RadioButtonGroup,
      FormError,
      Box,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <Text mdxType="Text">Basic input group</Text>
  <InputGroup mt="s" mb="m" mdxType="InputGroup">
    <Input name="field_1" placeholder="Placeholder for field 1" type="text" mdxType="Input" />
    <Input name="field_2" placeholder="Placeholder for field 2" type="text" mdxType="Input" />
    <Input name="field_3" placeholder="Placeholder for field 3" type="text" mdxType="Input" />
  </InputGroup>
  <Text mdxType="Text">Input group with a textarea</Text>
  <InputGroup mt="s" mb="m" mdxType="InputGroup">
    <Input name="field_1" placeholder="Placeholder for field 1" type="text" mdxType="Input" />
    <Input name="field_2" placeholder="Placeholder for field 2" type="text" mdxType="Input" />
    <TextArea name="field_3" placeholder="This is a textarea" type="text" mdxType="TextArea" />
  </InputGroup>
  <Text mdxType="Text">Input group with validated fields</Text>
  <InputGroup mt="s" mb="m" valid mdxType="InputGroup">
    <Input name="field_1" placeholder="Placeholder for field 1" type="text" value="Valid value" valid mdxType="Input" />
    <Input name="field_2" placeholder="Placeholder for field 2" type="text" value="Another valid value" valid mdxType="Input" />
    <Input name="field_3" placeholder="Placeholder for field 3" type="text" value="One more valid value" valid mdxType="Input" />
  </InputGroup>
  <Text mdxType="Text">Input group with an error</Text>
  <InputGroup mt="s" invalid mdxType="InputGroup">
    <Input name="field_1" placeholder="Placeholder for field 1" type="text" mdxType="Input" />
    <Input name="field_2" placeholder="Placeholder for field 2" type="text" value="Some invalid value" error="This field has an error" mdxType="Input" />
    <Input name="field_3" placeholder="Placeholder for field 3" type="text" value="A valid value" valid mdxType="Input" />
  </InputGroup>
    </Playground>
    <h3 {...{
      "id": "props-2"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'div'
      }, {
        name: 'valid',
        description: 'Value is valid',
        type: 'Boolean',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'invalid',
        description: 'Value is invalid',
        type: 'Boolean',
        defaultValue: 'undefined',
        responsive: 'false'
      }, ...COMMON, ...LAYOUT]}
    </PropsTable>
    <h2 {...{
      "id": "select"
    }}>{`Select`}</h2>
    <Playground __position={6} __code={'<Box mb=\"m\">\n  <Select>\n    <option>Option 1</option>\n    <option>Option 2</option>\n    <option>Option 3</option>\n  </Select>\n</Box>\n<Box mb=\"m\">\n  <Select label=\"Select label\">\n    <option>Option 1</option>\n    <option>Option 2</option>\n    <option>Option 3</option>\n  </Select>\n</Box>\n<Box mb=\"m\">\n  <Select error=\"This select has an error\">\n    <option>Option 1</option>\n    <option>Option 2</option>\n    <option>Option 3</option>\n  </Select>\n</Box>\n<Box>\n  <Select label=\"Select label\" error=\"This select has an error\">\n    <option>Option 1</option>\n    <option>Option 2</option>\n    <option>Option 3</option>\n  </Select>\n</Box>'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Input,
      TextArea,
      InputGroup,
      Select,
      Checkbox,
      RadioButton,
      RadioButtonGroup,
      FormError,
      Box,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <Box mb="m" mdxType="Box">
    <Select mdxType="Select">
      <option>Option 1</option>
      <option>Option 2</option>
      <option>Option 3</option>
    </Select>
  </Box>
  <Box mb="m" mdxType="Box">
    <Select label="Select label" mdxType="Select">
      <option>Option 1</option>
      <option>Option 2</option>
      <option>Option 3</option>
    </Select>
  </Box>
  <Box mb="m" mdxType="Box">
    <Select error="This select has an error" mdxType="Select">
      <option>Option 1</option>
      <option>Option 2</option>
      <option>Option 3</option>
    </Select>
  </Box>
  <Box mdxType="Box">
    <Select label="Select label" error="This select has an error" mdxType="Select">
      <option>Option 1</option>
      <option>Option 2</option>
      <option>Option 3</option>
    </Select>
  </Box>
    </Playground>
    <h3 {...{
      "id": "props-3"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'div'
      }, {
        name: 'fontSize',
        description: 'font-size',
        type: 'System',
        defaultValue: 'inherit'
      }]}
    </PropsTable>
    <h2 {...{
      "id": "checkbox"
    }}>{`Checkbox`}</h2>
    <Playground __position={8} __code={'<Checkbox label=\"A checkbox\" name=\"a_checkbox\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Input,
      TextArea,
      InputGroup,
      Select,
      Checkbox,
      RadioButton,
      RadioButtonGroup,
      FormError,
      Box,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <Checkbox label="A checkbox" name="a_checkbox" mdxType="Checkbox" />
    </Playground>
    <h3 {...{
      "id": "props-4"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'input'
      }, {
        name: 'label',
        description: 'A label',
        type: 'React node',
        defaultValue: 'undefined',
        responsive: 'false'
      }]}
    </PropsTable>
    <h2 {...{
      "id": "radiobutton"
    }}>{`RadioButton`}</h2>
    <Playground __position={10} __code={'<RadioButton\n  id=\"radio_button_field\"\n  label=\"A radio button\"\n  name=\"boolean_field\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Input,
      TextArea,
      InputGroup,
      Select,
      Checkbox,
      RadioButton,
      RadioButtonGroup,
      FormError,
      Box,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <RadioButton id="radio_button_field" label="A radio button" name="boolean_field" mdxType="RadioButton" />
    </Playground>
    <h3 {...{
      "id": "props-5"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'input'
      }, {
        name: 'label',
        description: 'A label',
        type: 'React node',
        defaultValue: 'undefined',
        responsive: 'false'
      }, {
        name: 'id',
        description: 'html id',
        type: 'String',
        defaultValue: 'undefined',
        responsive: 'false'
      }]}
    </PropsTable>
    <h2 {...{
      "id": "radiobuttongroup"
    }}>{`RadioButtonGroup`}</h2>
    <Playground __position={12} __code={'<Text>Basic radio button group</Text>\n<RadioButtonGroup mb=\"s\">\n  <RadioButton\n    id=\"radio_button_field_1\"\n    label=\"Radio field 1\"\n    name=\"radio_button_field_1\"\n  />\n  <RadioButton\n    id=\"radio_button_field_2\"\n    label=\"Radio field 2\"\n    name=\"radio_button_field_2\"\n  />\n</RadioButtonGroup>\n<Text>Radio button group with error</Text>\n<RadioButtonGroup error=\"This radio button group has an error\">\n  <RadioButton\n    id=\"radio_button_field_3\"\n    label=\"Radio field 3\"\n    name=\"radio_button_field_3\"\n  />\n  <RadioButton\n    id=\"radio_button_field_4\"\n    label=\"Radio field 4\"\n    name=\"radio_button_field_4\"\n  />\n</RadioButtonGroup>'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Input,
      TextArea,
      InputGroup,
      Select,
      Checkbox,
      RadioButton,
      RadioButtonGroup,
      FormError,
      Box,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <Text mdxType="Text">Basic radio button group</Text>
  <RadioButtonGroup mb="s" mdxType="RadioButtonGroup">
    <RadioButton id="radio_button_field_1" label="Radio field 1" name="radio_button_field_1" mdxType="RadioButton" />
    <RadioButton id="radio_button_field_2" label="Radio field 2" name="radio_button_field_2" mdxType="RadioButton" />
  </RadioButtonGroup>
  <Text mdxType="Text">Radio button group with error</Text>
  <RadioButtonGroup error="This radio button group has an error" mdxType="RadioButtonGroup">
    <RadioButton id="radio_button_field_3" label="Radio field 3" name="radio_button_field_3" mdxType="RadioButton" />
    <RadioButton id="radio_button_field_4" label="Radio field 4" name="radio_button_field_4" mdxType="RadioButton" />
  </RadioButtonGroup>
    </Playground>
    <h3 {...{
      "id": "props-6"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'div'
      }, {
        name: 'error',
        description: 'An error',
        type: 'React node',
        defaultValue: 'undefined',
        responsive: 'false'
      }, ...COMMON, ...LAYOUT]}
    </PropsTable>
    <h2 {...{
      "id": "formerror"
    }}>{`FormError`}</h2>
    <Playground __position={14} __code={'<FormError>Here is a form-level error</FormError>'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      LAYOUT,
      Input,
      TextArea,
      InputGroup,
      Select,
      Checkbox,
      RadioButton,
      RadioButtonGroup,
      FormError,
      Box,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <FormError mdxType="FormError">Here is a form-level error</FormError>
    </Playground>
    <h3 {...{
      "id": "props-7"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'div'
      }, ...COMMON, ...LAYOUT]}
    </PropsTable>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;